import React, {useEffect, useState} from 'react';

function ImageCarouselModal({ openModal, setOpenModal, files, activeIndex, setActiveIndex }) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE



    const handleWheel = (event) => {
        const delta = Math.sign(event.deltaY); // Get the direction of mouse scroll

        if (delta > 0) {
            // Scroll down: Show next image
            setActiveIndex((prevIndex) => Math.min(prevIndex + 1, files.length - 1));
        } else {
            // Scroll up: Show previous image
            setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
        }

        // Prevent default scroll behavior
        event.preventDefault();
    };


    useEffect(() => {
        if (!openModal) return;

        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight') {
                setActiveIndex((prevIndex) => Math.min(prevIndex + 1, files.length - 1));
            } else if (e.key === 'ArrowLeft') {
                setActiveIndex((prevIndex) => Math.max(prevIndex - 1, 0));
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, files.length]);



    return (
        <div className={"image-view-modal-container relative z-50"}>
            {openModal &&
                <>
                    {/*모달배경*/}
                    <div className={"image-view-modal-background"} onClick={()=>{
                        setOpenModal(false)
                        document.body.style.overflow = 'auto';
                    }}></div>


                    {/*모달창*/}
                    <div className={"image-view-modal  flex"} onWheel={handleWheel}>
                        {files.map((file, index) => (
                            <div className={`image-view-modal-each ${index === activeIndex ? 'active' : ''}`} key={index}>
                                <img className="inline-block" src={`${IMG_BASE}`+ `${file.path}`+`${file.uploadName}`} alt="이미지 설명" />
                            </div>
                        ))}
                    </div>

                    {/*인디케이터*/}
                    <div className="carousel-pointer-container">
                        {files.map((_, index) => (
                            <span className={`carousel-pointer ${index === activeIndex ? 'active' : ''}`}></span>
                        ))}
                    </div>
                </>
                }
        </div>
    );
}

export default ImageCarouselModal;
